<div class="container-fluid p-3">
  <mat-card>
    <mat-card-header class="pb-0">
      <mat-card-title>{{ editIndex !== null ? 'Editar' : 'Crear' }} Concepto de Comisión</mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-3">
      <form [formGroup]="comisionForm" (ngSubmit)="onGuardar()">
        <div class="row g-3 align-items-center">
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Código</mat-label>
              <input matInput formControlName="codigo" required placeholder="Código"
                     [matTooltip]="editIndex !== null ? 'No se puede modificar el código en modo edición' : ''"
                     [matTooltipPosition]="'above'">
              <mat-error *ngIf="comisionForm.get('codigo')?.hasError('required')">
                El código es requerido
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Descripción</mat-label>
              <input matInput formControlName="descripcion" required placeholder="Descripción">
              <mat-error *ngIf="comisionForm.get('descripcion')?.hasError('required')">
                La descripción es requerida
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Tipo</mat-label>
              <mat-select formControlName="tipo" required>
                <mat-option *ngFor="let tipo of tiposComision" [value]="tipo.value">
                  {{ tipo.label }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="comisionForm.get('tipo')?.hasError('required')">
                El tipo es requerido
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="d-flex gap-2 mt-3 justify-content-end">
          <button mat-flat-button color="primary" type="submit" [disabled]="!comisionForm.valid || isLoading"
            class="btn btn-primary">
            <span *ngIf="!isLoading">{{ editIndex !== null ? 'Actualizar' : 'Guardar' }}</span>
          </button>
          <button mat-flat-button type="button" (click)="resetForm()" *ngIf="editIndex !== null"
            class="btn btn-secondary">
            Cancelar
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card class="mt-3">
    <mat-card-header class="pb-0">
      <mat-card-title>Lista de Conceptos de Comisión</mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-3">
      <div class="row mb-3">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Buscar</mat-label>
            <input matInput [formControl]="searchControl" placeholder="Buscar por código,descripción o tipo...">
            <mat-icon matSuffix class="text-dark">search</mat-icon>
          </mat-form-field>
        </div>
      </div>


      <div class="table-responsive">
        <table mat-table [dataSource]="registros" class="table w-100">
          <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef style="width: 20%; font-size: 11px;">Código</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">{{element.codigo}}</td>
          </ng-container>

          <ng-container matColumnDef="descripcion">
            <th mat-header-cell *matHeaderCellDef style="width: 45%; font-size: 11px;">Descripción</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">{{element.descripcion}}</td>
          </ng-container>

          <ng-container matColumnDef="tipo">
            <th mat-header-cell *matHeaderCellDef style="width: 20%; font-size: 11px;">Tipo</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">{{element.tipo}}</td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef style="width: 15% ;text-align: center; font-size: 11px;">Acciones</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle;">
              <div style="display: flex; justify-content: center; gap: 4px;">
                <button mat-icon-button color="primary" [disabled]="!canEdit(element)" (click)="onEditar(element)"
                  matTooltip="{{ canEdit(element) ? 'Editar' : 'No se puede editar este concepto base' }}">
                  <mat-icon [ngClass]="{'text-dark': canEdit(element)}">edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" [disabled]="!canDelete(element)" (click)="onEliminar(element)"
                  matTooltip="{{ canDelete(element) ? 'Inactivar' : 'No se puede inactivar este concepto base' }}">
                  <mat-icon [ngClass]="{'text-dark': canDelete(element)}">delete</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['codigo', 'descripcion', 'tipo', 'acciones']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['codigo', 'descripcion', 'tipo', 'acciones'];"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize]="10" showFirstLastButtons></mat-paginator>
      </div>
    </mat-card-content>
  </mat-card>
</div>